/**
* this displays the fund overview
*
* Created by Paul on 27/05/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import NumberFormat from 'react-number-format'
import moment from 'moment'

// action import
import { ActionCreator } from '../../actions/'

// Configurations
import constants from '../../constants'
import config from '../../config'
import { isEmpty } from '../../utility/utilities'

// material-ui import
import { withStyles, makeStyles } from '@material-ui/styles'
import { createMuiTheme } from "@material-ui/core/styles"
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import Divider from '@material-ui/core/Divider'
import Done from '@material-ui/icons/Done'

import Expand from 'react-expand-animated'

import MUIDatePicker from '../../components/MUIDatePicker/'


// style import
import './style.scss'

const styles = theme => ({
    gridroot: {
        flexGrow: 1,
    },
    card: {
        width: '100%'
    },
    title: {
        fontSize: 16,
    },
    pos: {
        marginBottom: 12,
    },
    card_body: {
        fontSize: 13,
    },
    button: {
        fontSize: 11,
        '&:focus': {
            outline: 'none',
        },
    },
    link: {
        fontSize: 12,
        cursor: 'pointer'
    },
    icon: {
        position: 'relative',
        top: 3,
        left: 3,
        fontSize: 17,
    },
})

class FundReports extends Component {

    constructor(props) {
        super(props)

        this.state = {
            open: '',
            generalLetterMinuteReportRequested: false,
            contributionCapReportRequested: false,
            downloadFundDetailReportRequested: false,
            downloadInvestmentSummaryReportRequested: false,
            downloadMemberStatementReportRequested: false,
            centrelinkScheduleDataRequested: false,
            downloadRentalPropertyReportRequested: false,
        }

        this.handleRequestReport = this.handleRequestReport.bind(this)
    }

    toggle(report) {
        
        this.setState({ open: this.state.open === report ? '' : report })
    }

    renderReports() {

        const { classes, fundSummary } = this.props

        const currentYear = new Date().getFullYear()
        const generalLetterMinuteReportURL = config.endpoints.generalLetterMinuteReportURL + fundSummary.fund_code + '/'
        const contributionCapReportURL = config.endpoints.downloadContributionReportURL + fundSummary.fund_code + '/' + currentYear + '/'
        const downloadFundDetailReportURL = config.endpoints.downloadFundDetailReportURL + fundSummary.fund_code + '/'
        const downloadInvestmentSummaryReportURL = config.endpoints.downloadInvestmentSummaryReportURL + fundSummary.fund_code + '/' + currentYear + '-06-30/'
        const downloadMemberStatementReportURL = config.endpoints.downloadMemberStatementReportURL + fundSummary.fund_code + '/' + (currentYear - 1) + '-07-01/' + currentYear + '-06-30/'
        const downloadRentalPropertyReportURL = config.endpoints.downloadRentalPropertyReportURL + fundSummary.fund_code + '/' + currentYear + '/'

        return (
            <Card className={classes.card}>
                <CardContent>
                    
                    <Typography className={classes.title} variant="h5" component="h2">
                        On Demand Reports
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                        These reports are generated and downloaded immediately
                    </Typography>

                    <div>
                        <Button href={generalLetterMinuteReportURL} target="_blank" disabled={ this.state.generalLetterMinuteReportRequested } size="small" onClick={ () => this.setState({generalLetterMinuteReportRequested: true})}>Download General Minute / Letter Report</Button>
                                    { this.state.generalLetterMinuteReportRequested && <Done color="action" className={ classes.icon } /> }
                    </div>               

                    <div>
                        <Button href={contributionCapReportURL} target="_blank" disabled={ this.state.contributionCapReportRequested } size="small" onClick={ () => this.setState({contributionCapReportRequested: true})}>Download Contribution Cap Report</Button>
                                    { this.state.contributionCapReportRequested && <Done color="action" className={ classes.icon } /> }
                    </div>

                    <div>
                        <Button href={downloadFundDetailReportURL} target="_blank" disabled={ this.state.downloadFundDetailReportRequested } size="small" onClick={ () => this.setState({downloadFundDetailReportRequested: true})}>Download Fund Details Report</Button>
                                    { this.state.downloadFundDetailReportRequested && <Done color="action" className={ classes.icon } /> }
                    </div>

                    <div>
                        <Button href={downloadInvestmentSummaryReportURL} target="_blank" disabled={ this.state.downloadInvestmentSummaryReportRequested } size="small" onClick={ () => this.setState({downloadInvestmentSummaryReportRequested: true})}>Download Investment Summary Report</Button>
                                    { this.state.downloadInvestmentSummaryReportRequested && <Done color="action" className={ classes.icon } /> }
                    </div>

                    <div>
                        <Button href={downloadMemberStatementReportURL} target="_blank" disabled={ this.state.downloadMemberStatementReportRequested } size="small" onClick={ () => this.setState({downloadMemberStatementReportRequested: true})}>Download Member Statement Report</Button>
                                    { this.state.downloadMemberStatementReportRequested && <Done color="action" className={ classes.icon } /> }
                    </div>

                    <div>
                        <Button href={downloadRentalPropertyReportURL} target="_blank" disabled={ this.state.downloadRentalPropertyReportRequested } size="small" onClick={ () => this.setState({downloadRentalPropertyReportRequested: true})}>Download Rental Property Report</Button>
                                    { this.state.downloadRentalPropertyReportRequested && <Done color="action" className={ classes.icon } /> }
                    </div>


                    <br/><br/>


                    <Typography className={classes.title} variant="h5" component="h2">
                        Requested Reports
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                        To ensure the accuracy of these reports, Selfmade will assess the state of the fund before generating the report. The report will be emailed to your designated email address
                    </Typography>

                    <div>
                        <Button disabled={ this.state.centrelinkScheduleDataRequested } size="small" onClick={() => this.handleRequestReport('centrelinkScheduleData')}>Request Centrelink Schedule Data</Button>
                                    { this.state.centrelinkScheduleDataRequested && <Done color="action" className={ classes.icon } /> }
                    </div>


                </CardContent>
                
            </Card>
     
        )
    }

    handleRequestReport(report_name) {
        const { requestReport, fundSummary } = this.props
        this.setState({ centrelinkScheduleDataRequested: true })

        let payload = {
            report_name: report_name,
            fund_code: fundSummary.fund_code
        }

        requestReport(payload)
    }

    render() {
        
        const { classes } = this.props

        return (
            
            <ExpansionPanelDetails>

                <div className={classes.gridroot}>
                    <Grid container spacing={3}>

                        <Grid item xs={12}>
                            { this.renderReports() }
                        </Grid>


                    </Grid>
                </div>
                                        
            </ExpansionPanelDetails>
        )
    }
}

// define the prop types
FundReports.propTypes = {
    classes: PropTypes.object.isRequired,
}

const mapStateToPros = (state) => {
    return {
        fundSummary: state.fundState.fundSummary,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        requestReport: action.requestReport
    }
}

export default connect(mapStateToPros,mapDispatchToProps)(withStyles(styles)(FundReports))


// WEBPACK FOOTER //
// ./src/components/FundReports/index.js